module.exports = __webpack_public_path__ + "static/media/kia-star.13f86bc0.svg";